import { render } from "./OverallTwoImgComp.vue?vue&type=template&id=334d4bb2&scoped=true"
import script from "./OverallTwoImgComp.vue?vue&type=script&lang=js"
export * from "./OverallTwoImgComp.vue?vue&type=script&lang=js"

import "./OverallTwoImgComp.vue?vue&type=style&index=0&id=334d4bb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334d4bb2"]])

export default __exports__